"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CascaderBox = exports.getOptions = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Dropdown_1 = require("../dropdown/Dropdown");
var tabs_1 = require("../tabs");
var CascaderLoading_1 = require("./CascaderLoading");
var tips_1 = require("../tips");
var use_isomorphic_layout_effect_1 = require("../_util/use-isomorphic-layout-effect");
var util_1 = require("../util");
function getOptions(data, valueList) {
    var options = [];
    var curLevel = data;
    valueList.forEach(function (value) {
        var _a;
        var option = ((_a = curLevel === null || curLevel === void 0 ? void 0 : curLevel.options) === null || _a === void 0 ? void 0 : _a.find(function (option) { return option.value === value; })) || { value: value, label: null };
        options.push(option);
        if (option && option.child) {
            curLevel = option.child;
        }
        else {
            curLevel = {};
        }
    });
    return options.filter(Boolean);
}
exports.getOptions = getOptions;
function CascaderBox(_a) {
    var data = _a.data, curValue = _a.curValue, onLoad = _a.onLoad, onClose = _a.onClose, changeOnSelect = _a.changeOnSelect, scheduleUpdate = _a.scheduleUpdate, multiple = _a.multiple, isSelected = _a.isSelected, onSelect = _a.onSelect, onDeselect = _a.onDeselect, className = _a.className, style = _a.style;
    var classPrefix = util_1.useConfig().classPrefix;
    // 面板可用值（动态加载时预先传输 value 场景，此时值无法和面板数据对应）
    var availableValue = react_1.useMemo(function () {
        var _a, _b;
        var lists = [data];
        var value = [];
        var _loop_1 = function (i) {
            var option = (_b = (_a = lists[i]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.find(function (option) { return option.value === curValue[i]; });
            if (option) {
                value.push(curValue[i]);
            }
            if (option && option.child) {
                lists.push(option.child);
            }
            else {
                return "break";
            }
        };
        for (var i = 0; i < (curValue === null || curValue === void 0 ? void 0 : curValue.length); ++i) {
            var state_1 = _loop_1(i);
            if (state_1 === "break")
                break;
        }
        return value;
    }, [curValue, data]);
    // 内部状态
    var _b = tslib_1.__read(react_1.useState(availableValue || []), 2), internalValue = _b[0], setInternalValue = _b[1];
    use_isomorphic_layout_effect_1.useIsomorphicLayoutEffect(function () {
        setInternalValue(availableValue || []);
    }, [curValue]);
    // 面板
    var panels = react_1.useMemo(function () {
        var _a, _b;
        var panels = [data];
        var _loop_2 = function (i) {
            var option = (_b = (_a = panels[i]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.find(function (option) { return option.value === internalValue[i]; });
            if (option && option.child) {
                panels.push(option.child);
            }
            else {
                return "break";
            }
        };
        for (var i = 0; i < internalValue.length; ++i) {
            var state_2 = _loop_2(i);
            if (state_2 === "break")
                break;
        }
        return panels;
    }, [data, internalValue]);
    var _c = tslib_1.__read(react_1.useState(panels.length - 1), 2), curPanelIndex = _c[0], setCurPanelIndex = _c[1];
    use_isomorphic_layout_effect_1.useIsomorphicLayoutEffect(function () {
        if (scheduleUpdate) {
            scheduleUpdate();
        }
    }, [curPanelIndex, scheduleUpdate]);
    function handleSelect(index, value, _a) {
        var event = _a.event, hasChild = _a.hasChild;
        var newValue = tslib_1.__spread(internalValue.slice(0, index), [value]);
        if (changeOnSelect) {
            onSelect(newValue, { event: event, options: getOptions(data, newValue) });
        }
        else {
            setInternalValue(newValue);
            if (!hasChild) {
                onSelect(newValue, { event: event, options: getOptions(data, newValue) });
            }
        }
        if (hasChild) {
            setCurPanelIndex(index + 1);
        }
        else if (!multiple) {
            onClose();
        }
    }
    return (react_1.default.createElement(Dropdown_1.DropdownBox, { className: className, style: style },
        react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-cascader-menu", classPrefix + "-cascader-menu__col" + ((panels[curPanelIndex] &&
                panels[curPanelIndex].col) ||
                4)) },
            react_1.default.createElement(tabs_1.Tabs, { className: classPrefix + "-tabs--bordered", animated: false, activeId: String(curPanelIndex), onActive: function (_a) {
                    var id = _a.id;
                    return setCurPanelIndex(+id);
                }, tabs: panels.map(function (_a, index) {
                    var title = _a.title;
                    return ({
                        id: String(index),
                        label: title,
                    });
                }) }, panels.map(function (_a, index) {
                var options = _a.options;
                return (react_1.default.createElement(tabs_1.TabPanel, { id: String(index), key: index }, options ? (react_1.default.createElement("ul", { className: classPrefix + "-cascader-menu__list", style: options.length === 0
                        ? { margin: 0, overflow: "hidden" }
                        : {} },
                    options.map(function (_a) {
                        var value = _a.value, label = _a.label, child = _a.child, disabled = _a.disabled;
                        var optionValue = tslib_1.__spread(internalValue.slice(0, index), [
                            value,
                        ]);
                        var selected = multiple
                            ? isSelected(optionValue)
                            : internalValue[index] === value;
                        return (react_1.default.createElement("li", { key: tslib_1.__spread(internalValue.slice(0, index), [value]).join("/") },
                            react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-cascader-menu__label", {
                                    "is-selected": selected,
                                    "is-disabled": disabled,
                                }), onClick: function (event) {
                                    if (disabled) {
                                        return;
                                    }
                                    if (multiple && selected) {
                                        onDeselect(optionValue, {
                                            event: event,
                                            options: getOptions(data, optionValue),
                                        });
                                        return;
                                    }
                                    handleSelect(index, value, {
                                        event: event,
                                        hasChild: Boolean(child),
                                    });
                                } }, label || value)));
                    }),
                    options.length === 0 && react_1.default.createElement(tips_1.EmptyTip, null))) : (react_1.default.createElement("ul", { className: classPrefix + "-cascader-menu__list", style: { margin: 0, overflow: "hidden" } },
                    react_1.default.createElement(CascaderLoading_1.CascaderLoading, { onLoad: function () {
                            return onLoad(internalValue, getOptions(data, internalValue));
                        } })))));
            })))));
}
exports.CascaderBox = CascaderBox;
CascaderBox.displayName = "CascaderBox";
//# sourceMappingURL=CascaderBox.js.map